import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle.js";
import { type_constant } from "../utils/asyncStatus.js";

export const getAllStoresAsync = createAsyncThunk(
  type_constant.GET_ALL_STORES_ASYNC,
  async () => {
    try {
      const response = await apiHandle.get(`all-stores`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const getStoreByIdAsync = createAsyncThunk(
  type_constant.GET_STORE_BY_ID_ASYNC,
  async (id) => {
    try {
      const response = await apiHandle.get(`admin/view-store/${id}`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const updateStoreStatusAsync = createAsyncThunk(
  type_constant.UPDATE_STORE_STATUS_ASYNC,
  async (updatedData) => {
    try {
      const response = await apiHandle.post(
        `admin/store-status-update`,
        updatedData
      );
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
